import { useState, useEffect } from 'react';
import { apiStates } from './apiStates';

import { getMe } from '../services/measureSvc';

export const useMyProfile = () => {
  const [data, setData] = useState({
    state: apiStates.LOADING,
    error: '',
    data: {},
  });
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    setTimeout(async () => {
      const tmp = {}
      tmp.state = apiStates.LOADING;
      setData(tmp);

      try {
        const res = await getMe();
        console.log(res);

        if (res && res.data) {
          tmp.state = apiStates.SUCCESS;
          tmp.data = res.data;
          tmp.error = '';
          setData(tmp);
          setProfile({...res.data})
        } else {
          setData({
            state: apiStates.ERROR,
            error: 'No data returned',
            data: {},
          });
        }
      } catch (error) {
        setData({
          state: apiStates.ERROR,
          error: error,
          data: {},
        });
      }
    });
  }, []);

  return {data, profile};
};
